import { useMutation } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import { ADD_MEMBERS } from "../../mutations/rolesAndPermissions/addMembers";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";

export const useAddMembers = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [addMembers, { data, loading, error }] = useMutation(ADD_MEMBERS, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER_GROUPS, GET_USER_GROUP, GET_USERS],
    awaitRefetchQueries: true,
  });

  return { addMembers, data, loading, error };
};
